import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import TableContent from '../../components/table/TableContent';
import { tableCellDefined } from '../../components/table/tableData';
import NoData from '../../components/alert/NoData';
import { TablePaper } from '../../components/customStyles/box';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.875rem',
    paddingTop: '12px',
    paddingBottom: '12px', 
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.secondary.w50,
  },
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    '&:hover': {
      backgroundColor: theme.palette.secondary.w50,
    },
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


const WorkListTableV1 = (props) => {
  const { resultData, isLoading, handleTableAction } = props;

  return (
    <>
      <TablePaper>
        <TableContainer>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                {
                  tableCellDefined.map((header) => (
                    <StyledTableCell align={header.align} key={header.id}>
                      {header.name}
                    </StyledTableCell>
                  ))
                }
              </TableRow>
            </TableHead>

            <TableBody>
              {
                !isLoading &&
                resultData &&
                resultData?.length > 0 &&
                resultData.map((row, index) => (
                  <StyledTableRow key={`${index}-${row.account_id}`}>
                    {
                      tableCellDefined.map((header, index) => (
                        <StyledTableCell component="th" scope="row" key={`${index}-${header.id}`} align={header.align}>
                          <TableContent
                            header={header}
                            rowData={row}
                            handleTableAction={handleTableAction}
                          />
                        </StyledTableCell>
                      ))
                    }
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
          {
            !isLoading &&
            !resultData?.length &&
            <NoData />
          }
        </TableContainer>

        {/* <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
      </TablePaper>
    </>
  )
}

export default WorkListTableV1;